// import styles from './NotFound.module.less';

const NotFound = (props) => {
  return <div>Page Not Found</div>;
};

export default NotFound;
